<template>
    <div class="wrapper">
        <CCHeader></CCHeader>
        <div class="data-wrapper">
            <CCSideBar></CCSideBar>
            <div class="main" v-bind:class="{'loaded-data': reportData.rows.length >= 25}">
                <div class="report" v-bind:class="{'sidebar-active': getSideBarStatus()}">
                    <CCReportFilters :namespace="namespace"></CCReportFilters>
                    <div class="table-main">
                        <div class="report-table-wrapper">
                            <div class="table-header">

                                <template v-if="$md.mobile() !== null">
                                    <div class="control-wrapper-mobile">
                                        <div>
                                            <CCCalendar :actionEvent="this.setDateRanges" :namespace="namespace"></CCCalendar>
                                        </div>
                                        <div class="columns-customization-mobile">
                                            <CCTableCustomizationColumns :columns="columns" :defaultColumns="defaultColumns" :namespace="namespace"></CCTableCustomizationColumns>
                                        </div>
                                    </div>
                                </template>
                                <template v-else>
                                    <h4 class="table-header-title">
                                    <span v-if="selectedSites != null">
                                        Adgroups for
                                        {{prepareSelectedOptionsNames(selectedSites, 'name')}}
                                    </span>
                                    </h4>
                                    <div class="control-wrapper">
                                        <div class="search-wrapper">
                                            <input type="text" name="search" v-model="search" v-on:keyup.enter="useSearch()" placeholder="Search">
                                            <div @click="useSearch()">
                                                <i class="search-icon"></i>
                                            </div>
                                        </div>
                                        <div class="columns-customization-wrapper">
                                            <CCTableCustomizationColumns :columns="columns"
                                                                         :defaultColumns="defaultColumns"
                                                                         :namespace="namespace">
                                            </CCTableCustomizationColumns>
                                        </div>
                                    </div>
                                </template>
                            </div>
                            <div class="tables-list">
                                <CCTable v-if="reportData.rows.length"
                                         :data="reportData"
                                         :sortColumnsList="sortColumnsList"
                                         :isDatesComparisonEnabled="isDatesComparisonEnabled"
                                         :fieldNameDropDown="fieldNameDropDown"
                                         :dropDownMenuUrls="dropDownMenuUrls"
                                         :namespace="namespace"
                                         :editableFieldsList="editableFieldsList"
                                         @sortMultipleColumn="applyMultipleColumn"
                                         @sortColumn="applySorting">
                                </CCTable>

                                <template v-if="reportData.rows.length === 0">
                                    <div class="table-no-results">There are no results with these filters.</div>
                                </template>
                            </div>
                            <div class="table-wrapper-bottom">
                                <div class="action-button-wrapper">
                                    <button @click="exportReportAsCSV()">Export as CSV</button>
                                </div>
                                <CCTablePagination v-if="reportData.rows.length"
                                                   :numberRows="reportData.rows.length"
                                                   :paginationOptions="paginationOptions"
                                                   :limit="$store.getters[namespace + '/getPaginationLimit']"
                                                   :totalCount="totalCount"
                                                   @changePagination="onChangePagination"
                                                   @previousPage="previousPage"
                                                   @nextPage="nextPage"></CCTablePagination>
                            </div>
                        </div>
                        <CCTableRightSideBar :data="chartsData" :namespace="namespace" showChartsButton v-show="chartsData"></CCTableRightSideBar>
                    </div>
                </div>
            </div>
        </div>
        <Loading :active="loadingStatus" :can-cancel="false" :on-cancel="whenCancelled"></Loading>
    </div>
</template>

<script>

    import '@/style/reports/base_report_style.scss';

    import adgroupReportModule from '@/store/modules/adgroupReport/index';
    import baseReportFiltersModule from '@/store/modules/baseReport/filter/index';
    import baseReportDataModule from '@/store/modules/baseReport/table/index';

    import CCHeader from '@/components/common/CCHeader';
    import CCSideBar from '@/components/common/CCSideBar';
    import CCReportFilters from '@/components/common/CCReportFilters';
    import CCAdgroupReportTable from '@/components/reports/adgroupReport/CCAdgroupReportTable';
    import {reportColumnsDefinitions, fieldNameDropDown, dropDownMenuUrls, editableFieldsList} from '../configs/adgroup-report-config';
    import moment from 'moment';

    import baseReportMixin from '@/components/mixins/baseReportMixin';
    import URLSyncMixin from '@/components/mixins/URLSyncMixin.js';

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.min.css';

    import tableMixin from '@/components/common/table/tableMixin';
    import CCTablePagination from '@/components/common/table/CCTablePagination';
    import paginationMixin from '@/components/common/table/paginationMixin';
    import sortTableMixin from '@/components/reports/mixins/sortTableMixin';
    import CCTableCustomizationColumns from '@/components/reports/common/table/CCTableCustomizationColumns';
    import CCTableRightSideBar from '@/components/reports/common/table/CCTableRightSideBar';

    import CCTable from '@/components/common/table/CCTable';

    import {isEmptyObject} from '@/helpers/check_variable_types';

    export default {
        name: "adgroup-report",
        components: {
            CCHeader,
            CCSideBar,
            CCReportFilters,
            CCAdgroupReportTable,
            Loading,

            CCTable,
            CCTablePagination,
            CCTableCustomizationColumns,
            CCTableRightSideBar
        },
        mixins: [
            URLSyncMixin,
            baseReportMixin,
            tableMixin,
            paginationMixin,
            sortTableMixin
        ],
        data(){
            return {
                namespace: 'adgroupReport',
                defaultColumns: reportColumnsDefinitions,
                columns: [],
                isFiltersLoadingStart: false,
                search: null,
                chartsData: null,
                openChartsSideBar: this.$store.getters[this.namespace + '/getSideBarStatus'],
                fieldNameDropDown: fieldNameDropDown,
                dropDownMenuUrls: dropDownMenuUrls,
                editableFieldsList: editableFieldsList
            }
        },
        beforeCreate(){
            if (!('adgroupReport/' in this.$store._modulesNamespaceMap))
            {
                this.$store.registerModule('adgroupReport', {
                    namespaced: true,
                    modules: {
                        baseReportDataModule,
                        baseReportFiltersModule,
                        adgroupReportModule
                    }
                });
            }
        },
        created(){
            for (let i = 0; i < reportColumnsDefinitions.length; i++) {
                reportColumnsDefinitions[i]['position'] = i;
            }
            /*if (!this.checkParameterURLExists('siteId') && !this.checkParameterURLExists('sourceId'))
            {
              this.showNotificationEmptyFilters();
            }*/

            this.$store.watch(() => this.$store.getters[this.namespace + '/getChartUpdatingStatus'], (isNeedToUpdate) => this.getSummaryReportData(isNeedToUpdate));
        },
        mounted() {

            this.$store.getters[this.namespace + '/getFilters'];
        },
        watch: {
            reportData: function(value)
            {
                let urlParams = this.$store.getters.getURLParams;

                if (!isEmptyObject(urlParams))
                {
                    if (!this.loadingStatus && value.length === 0)
                    {
                        this.showNofiticationEmptyData();
                    }
                }
            }
        },
        computed: {
            reportData: function(){
                let data = this.getReportDataGetter();
                let preparedData = null;

                if (this.isDatesComparisonEnabled)
                {
                    let dateRange = this.$store.getters[this.namespace + '/getFilterValueByFilterName']('dateRange');
                    preparedData = this.prepareDataForDateComparison(data, this.columns, dateRange);
                }
                else
                {
                    preparedData = this.prepareDataForTable(data, this.columns);
                }

                return preparedData;
            },
            totalCount: function(){
                return this.$store.getters[this.namespace + '/getReportTotalCount'];
            },
            loadingStatus: function(){
                return this.getLoadingStatus();
            },
            getScrollOffsetY: function(){
                return this.$store.getters.getScrollOffsetY;
            },
            selectedSites: function(){
                let sites = this.$store.getters.getSitesList;
                let selectedSitesIds = this.$store.getters[this.namespace + '/getFilterValueByFilterName']('siteId');

                if (selectedSitesIds.length)
                {
                    return sites.filter(item => selectedSitesIds.includes(item.id));
                }

                return null;
            },
            isDatesComparisonEnabled: function(){
                return this.$store.getters[this.namespace + '/isDatesComparisonEnabled'];
            }
        },
        methods: {
            getSummaryReportData: function(isNeedToUpdate){
                var that = this;

                if (isNeedToUpdate)
                {
                    let filters = {
                        reportFilters: null,
                        sorting: {
                            sortColumn: null,
                            sortDirection: null
                        }
                    };

                    let filtersList = this.getReportFilters();

                    filters.reportFilters = filtersList.filters;
                    filters.columns = this.getReportColumns();
                    filters.sorting.sortColumn = this.getSortColumn();
                    filters.sorting.sortDirection = this.getSortDirection();

                    let updatedFilters = Object.assign({}, filters);

                    if (
                        filters.reportFilters.dateRange.startDate !== undefined && filters.reportFilters.dateRange.startDate !== null &&
                        filters.reportFilters.dateRange.endDate !== undefined && filters.reportFilters.dateRange.endDate !== null
                    )
                    {
                        let dateStart = moment(filters.reportFilters.dateRange.startDate).clone();
                        let dateEnd = moment(filters.reportFilters.dateRange.endDate).clone();

                        let startDate = dateStart;
                        let endDate = dateEnd;

                        if (dateEnd.diff(dateStart, 'days') < 4)
                        {
                            startDate = dateEnd.clone().add(-6, 'days');
                            endDate = dateEnd.clone();
                        }

                        var generateDatesList = function(startDate, endDate){
                            let dates = [];
                            let day = startDate.clone();

                            dates.push(startDate);

                            while (day.isBefore(endDate, 'day'))
                            {
                                day = day.add(1, 'day');

                                dates.push(day);
                            }

                            return dates;
                        };

                        updatedFilters.reportFilters.dates = generateDatesList(startDate, endDate);

                        let urlParams = this.$store.getters.getURLParams;

                        if (!isEmptyObject(urlParams))
                        {
                            let chartsObjects = this.$store.dispatch(this.namespace + '/getSummaryReportChartsData', updatedFilters);

                            chartsObjects.then(function(result){
                                if (result && result.report !== undefined)
                                {
                                    that.chartsData = result.report.edges;
                                }
                                else
                                {
                                    that.$notification.setPosition('topRight')
                                        .setCloseStatus(true)
                                        .setCloseOnClick(true)
                                        .setCloseOnEscape(true)
                                        .setTimeout(false)
                                        .setSettings();

                                    that.$notification.showWarning('Warning!', 'There are no data for chart with these filters');
                                }
                            });
                        }
                    }
                }
            },
            fixColumn: function(column){
                if (this.fixedColumnsList.length)
                {
                    let key = this.fixedColumnsList.findIndex(index => index === column);

                    if (key != -1)
                    {
                        this.fixedColumnsList.splice(key, 1);
                    }
                    else
                    {
                        this.fixedColumnsList.push(column);
                    }
                }
                else
                {
                    this.fixedColumnsList.push(column);
                }
            },
            whenCancelled: function(){

            },
            useSearch: function(){
                if (this.search == '')
                {
                    this.search = null;
                }

                this.$store.dispatch(this.namespace + '/setReportSearch', this.search);
                this.$store.dispatch(this.namespace + '/startLoading');
                this.$store.dispatch(this.namespace + '/setUpdatingStatus', true);
            },
            prepareSelectedOptionsNames(objects, nameField){
                let formattedNames = null;
                let names = objects.map(item => item[nameField]);

                formattedNames = names.slice(0, 2).join(', ');

                if (names.length > 2)
                {
                    formattedNames += ' + ' + (names.length - 2) + ' more';
                }

                return formattedNames;
            },
            exportReportAsCSV: function(){
                let that = this;

                this.$store.dispatch(this.namespace + '/startLoading');

                let filtersData = {
                    reportFilters: null,
                    sorting: {
                        sortColumn: null,
                        sortDirection: null
                    },
                    format: 'CSV'
                };

                filtersData.reportFilters = this.getReportFilters();
                filtersData.columns = this.getReportColumns();
                filtersData.paginationData = this.getPagination();
                filtersData.sorting.sortColumn = this.getSortColumn();
                filtersData.sorting.sortDirection = this.getSortDirection();

                let report  = this.$store.dispatch(this.namespace + '/getReportDataFromAPI', filtersData);

                report.then(function(result)
                {
                    if (result.size > 0)
                    {
                        var a = window.document.createElement("a");
                        a.href = window.URL.createObjectURL(result, {type: result.type});
                        a.download = that.namespace + ".csv";
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    }
                    else
                    {
                        that.$notification.showWarning('API Error!', 'Something is wrong');
                    }
                }).finally(function(){
                    that.$store.dispatch(that.namespace + '/finishLoading');
                });
            },
        }
    }
</script>

<style lang="scss" scoped>

    .table-main {
        display: flex;
        max-width: calc(100% - 64px);
    }

    .report-table-wrapper {
        width: 100%;
        display: block;
        background-color: #fff;
        padding: 20px 20px 0px 20px;

        & > .table-header {
            margin-bottom: 45px;
        }

        & > .tables-list {
            display: flex;
            flex-direction: row;
            width: 100%;
        }
    }

    .control-wrapper {
        margin-right: 0;
    }

    .table-no-results {
        margin-top: 20px;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        justify-self: center;
        justify-items: center;
        width: 100%;
    }

    .table-wrapper-bottom {
        display: grid;
        grid-template-columns: 1fr 1fr;
        background-color: #fff;
        /*margin-bottom: 15px;*/
        padding-bottom: 15px;
    }

    .table-wrapper-bottom {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: baseline;

        & > .action-button-wrapper {
            text-align: left;

            & > button {
                font-size: 12px;
                font-weight: bolder;
                /*background-color: #fff;*/
                background-image: linear-gradient(to bottom, #fbfbfb 0%, #f5f5f5 50%, #ededed 100%);
                color: #676767;
                padding: 8px 20px;
                border: 1px solid #d7d7d7;
                border-radius: 3px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/AdgroupReport.vue